import { UserManager } from "oidc-client";
import { AUTH_CONFIG } from "../environmentVariables";

const userManager = new UserManager(AUTH_CONFIG.saml);

export async function getUser() {
    const user = await userManager.getUser();
    return user;
}

export async function isAuthenticated() {
    let token = await getAccessToken();

    return !!token;
}

export async function handleOAuthCallback() {
    try {
        await userManager.signinRedirectCallback();
        return true;
    } catch (e) {
        await userManager.clearStaleState();
        console.log(`error while handling oauth callback: ${e}`);
    }
}

export async function sendOAuthRequest() {
    return await userManager.signinRedirect();
}

export async function getAccessToken() {
    const user = await getUser();
    return user?.access_token;
}
